import { defineMessages } from "react-intl";

import {
	cardiovascularDiseaseTypeMessages,
	coronaryDiseaseTypeMessages,
	hasDiseaseMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/cardiovascularDiseases";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	cardiovascularDiseases: {
		id: "ktx.form.cardiovascularDiseases.title",
		defaultMessage: "Kardiovaszkuláris betegségek"
	},
	hasDisease: {
		id: "ktx.form.cardiovascularDiseases.hasDisease",
		defaultMessage: "Betegségek?"
	},
	diseases: {
		id: "ktx.form.cardiovascularDiseases.value",
		defaultMessage: "Betegségek"
	},
	coronaryDisease: {
		id: "ktx.form.cardiovascularDiseases.coronary",
		defaultMessage: "Koronáriabetegség"
	},
	comment: {
		id: "ktx.form.cardiovascularDiseases.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["hasDisease"],
						label: messages.hasDisease,
						errorMessages: genericErrorMessages,
						input: {
							type: "button-group",
							props: {
								labels: hasDiseaseMessages
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["diseases", "cardiovascularDiseaseType"],
						label: messages.diseases,
						errorMessages: genericErrorMessages,
						input: {
							type: "checkbox-group",
							props: {
								labels: cardiovascularDiseaseTypeMessages,
								direction: "vertical",
								columns: 2
							}
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["diseases", "coronaryDiseaseType"],
						label: messages.coronaryDisease,
						errorMessages: genericErrorMessages,
						input: {
							type: "select",
							props: { labels: coronaryDiseaseTypeMessages }
						}
					}
				}
			]
		},
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["comment"],
						label: messages.comment,
						errorMessages: genericErrorMessages,
						input: {
							type: "textarea",
							props: {}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_cardiovascularDiseases",
	value: {
		schemaId: "cardiovascularDiseases",
		title: messages.cardiovascularDiseases,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
